<template>
  <v-btn v-bind="$attrs" color="primary">{{ title }}</v-btn>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' }
  }
}
</script>
